
/*
===============================================================
Title:  Listado de compras realizadas a un producto
Date:   21/10/2025
Description: Recibe el id de un insumo de tattoo y lista
todas las compras realizadas a ese insumo
===============================================================
*/
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import style from "../../styles/grid.module.css";

const Reportecompras = () => {
   const url = process.env.REACT_APP_URL_DIR + "sqlraw/sql";
   const token = localStorage.getItem("token");
   const navigate = useNavigate();
   const location = useLocation();
   const { state } = location;
   const [results, setResults] = useState([]);
   const [input, setInput] = useState({
      id: state ? state.id : 0,
   });
   useEffect(() => {
       const fetchData = async () => {
          var sql = `select c.fecha,i2.descripcion,i.cantidad,i.precio from compratattooinsumo i`;
          sql += ` join compratattoo c on c.id_primary = i."compraIdPrimary" `;
          sql += ` join insumo i2 on i2.id_primary  = i."insumoIdPrimary" `;
          sql += ` where i."insumoIdPrimary" = ${input.id}`;
          console.log('sql: ', sql);

          const response = await fetch(`${url}/${sql}`, {
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         });
         const data = await response.json();
         setResults(Array.isArray(data) ? data : [data]);
      };
   fetchData();
   }, []);

   const formatDate = (fecha) => {
      var newDate1 = fecha.substring(0, 10).split("-");
      var newdate2 = newDate1[2] + "/" + newDate1[1] + "/" + newDate1[0];
      return newdate2;
   };
   
   return (
      <div style={{width: '70%', margin: 'auto' }}>
         <h3 style={{textAlign: 'center', borderRadius: '10px', backgroundColor:"White",color: 'black',    padding: '10px', marginBottom: '15px'}}>Listado de compras realizadas a un producto</h3>
         <table className={style.table}>
            <thead>
               <tr>
                  <th>Fecha</th>
                  <th>Descripcion</th>
                  <th>Cantidad</th>
                  <th>Precio</th>
               </tr>
            </thead>
            <tbody>
               {results.map((compra,idx) => (
                  <tr key={idx}>
                     <td>{formatDate(compra.fecha)}</td>
                     <td>{compra.descripcion}</td>
                     <td style={{ textAlign: 'center' }}>{compra.cantidad}</td>
                     <td style={{ textAlign: 'right' }}>{compra.precio}</td>
                  </tr>
               ))}
            </tbody>
                                  <tr>
                                             <td colSpan={4}>
                                                &nbsp;&nbsp;&nbsp;&nbsp;
                                                <button
                                                   className={style.inputBtnNew}
                                                   onClick={() => {
                                                      navigate("/insumost");
                                                   }}
                                                >
                                                   VOLVER
                                                </button>
                                             </td>
                                          </tr>
         </table>
      </div>
   );
};

export default Reportecompras;
